/**
 * #613 #609 #624 #627 — the platform's own routes and the standard app pages every declared menu item
 * opens (a declared item must open a screen). Mounted by app/routes.tsx under the shell.
 */
import { lazy, Suspense, type ComponentType } from 'react';
import type { RouteObject } from 'react-router-dom';
import { RouteFallback } from '@/app/shell/RouteFallback';
import { HELP_ROUTES } from '@/features/help/routes';

function page(load: () => Promise<{ default: ComponentType }>) {
  const Lazy = lazy(load);
  return (
    <Suspense fallback={<RouteFallback />}>
      <Lazy />
    </Suspense>
  );
}

const MyRequests = lazy(() => import('@/features/requests/MyRequestsPage'));

export const PLATFORM_ROUTES: RouteObject[] = [
  { path: 'apps', element: page(() => import('./AppsPortalPage')) },
  // R-14 T-068: the app's home for the user's scope (a chooser when there are several)
  { path: 'apps/:slug/home', element: page(() => import('./AppHomePage')) },
  { path: 'apps/:slug/about', element: page(() => import('./AppAboutPage')) },
  { path: 'apps/:slug/ai-access', element: page(() => import('./AppAiAccessPage')) },
  // R11 #668 (L4): Help › App standard (help/app-standard).
  ...HELP_ROUTES,
  { path: 'approvals', element: page(() => import('@/features/approvals/ApprovalsPage')) },
  {
    path: 'my-requests',
    element: (
      <Suspense fallback={<RouteFallback />}>
        <MyRequests />
      </Suspense>
    ),
  },
  // R11 #661 (L2): one request's workspace, its stages as tabs.
  { path: 'my-requests/:id', element: page(() => import('@/features/requests/RequestWorkspacePage')) },
  {
    path: 'my-requests/new',
    element: (
      <Suspense fallback={<RouteFallback />}>
        <MyRequests requestChange />
      </Suspense>
    ),
  },
];
